'use strict';

/**
 * Pulse record drawer — URL `open=` stays on /projects/:id/pulse.
 * Never serializes /pay-apps/ wizard paths.
 */

function num(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function parsePulseOpen(raw) {
  const s = String(raw || '').trim();
  if (!s) return null;
  const parts = s.split(':');
  const kind = parts[0];
  if (kind === 'document') {
    const source = parts[1] === 'att' ? 'att' : 'hub';
    const id = num(parts[2]);
    return id != null ? { kind: 'document', source, id } : null;
  }
  if (kind === 'change_order') {
    const id = num(parts[1]);
    return id != null ? { kind: 'change_order', id } : null;
  }
  if (kind === 'pay_app') {
    const id = num(parts[1]);
    return id != null ? { kind: 'pay_app', id } : null;
  }
  if (kind === 'payments') {
    const highlight = parts[1] === 'retainage' || parts[1] === 'received' ? parts[1] : undefined;
    return highlight ? { kind: 'payments', highlight } : { kind: 'payments' };
  }
  return null;
}

function serializePulseOpen(open) {
  if (!open) return '';
  if (open.kind === 'document') return `document:${open.source || 'hub'}:${open.id}`;
  if (open.kind === 'change_order') return `change_order:${open.id}`;
  if (open.kind === 'pay_app') return `pay_app:${open.id}`;
  if (open.kind === 'payments') return open.highlight ? `payments:${open.highlight}` : 'payments';
  return '';
}

function openFromEvent(event) {
  const rec = (event && event.record) || {};
  const kind = String(rec.kind || '');
  const id = num(rec.id);
  if (kind === 'document') {
    const eid = String(event.id || '');
    const recSource = rec.source === 'att' || rec.source === 'hub' ? rec.source : null;
    const source = recSource
      || (eid.startsWith('att:') ? 'att' : null)
      || (eid.startsWith('hub:') ? 'hub' : null)
      || (rec.change_order_id != null || rec.attachment_id != null ? 'att' : 'hub');
    return id != null ? { kind: 'document', source, id } : null;
  }
  if (kind === 'change_order' && id != null) return { kind: 'change_order', id };
  if (kind === 'pay_app') {
    const pa = num(rec.pay_app_id) ?? id;
    return pa != null ? { kind: 'pay_app', id: pa } : null;
  }
  if (kind === 'payment') {
    const pa = num(rec.pay_app_id);
    return pa != null ? { kind: 'pay_app', id: pa } : null;
  }
  if (kind === 'closeout' || kind === 'project') return { kind: 'payments' };
  return null;
}

export { parsePulseOpen, serializePulseOpen, openFromEvent };
